/**
 * Navigation Module
 * Handles mega menu and mobile navigation
 */

import { $, $$, on, addClass, removeClass, toggleClass, closest } from '../utils/dom.js';

export const initNavigation = () => {
  // Header scroll behavior
  initHeaderScroll();

  // Mega Menus
  on($$(".main-nav__menu li a"), "mouseenter", function (e) {
    e.preventDefault();
    const parentLi = closest(this, "li");
    if (parentLi && parentLi.classList.contains("mega-menu-toggle")) {
      const target = this.getAttribute("href").split("#")[1];
      megaMenuToggle(target);
    } else {
      window.location.href = this.getAttribute("href");
    }
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".mega-menu") && !e.target.closest(".mega-menu-toggle")) {
      megaMenuClose();
    }
  });

  on($$(".mega-menu"), "mouseleave", function () {
    megaMenuClose();
  });

  // Mobile Nav
  on($$(".main-nav__menu-toggle"), "click", function (e) {
    e.preventDefault();
    toggleClass(".mobile-nav", "active");
  });

  on($$(".mobile-nav__close"), "click", function (e) {
    e.preventDefault();
    removeClass(".mobile-nav", "active");
  });

  on($$(".mobile-nav__menu li a"), "click", function (e) {
    e.preventDefault();
    const parentLi = closest(this, "li");
    if (parentLi && parentLi.classList.contains("mega-menu-toggle")) {
      const target = this.getAttribute("href").split("#")[1];
      megaMenuToggle(target);
    } else {
      window.location.href = this.getAttribute("href");
    }
  });

  on($$(".mobile-nav__back"), "click", function () {
    removeClass(".mega-menu", "active");
    removeClass(".mega-menu-overlay", "active");
    removeClass(".main-nav", "mega-menu-open");
  });

  function megaMenuToggle(target) {
    removeClass(".mega-menu__group", "active");
    addClass(".mega-menu", "active");
    addClass(`.mega-menu__group[data-menu="${target}"]`, "active");
    addClass(".mega-menu-overlay", "active");
    addClass(".main-nav", "mega-menu-open");
  }

  function megaMenuClose() {
    removeClass(".mega-menu", "active");
    removeClass(".mega-menu-overlay", "active");
    removeClass(".main-nav", "mega-menu-open");
  }
};

/**
 * Header scroll behavior
 * Hides header on scroll down, shows on scroll up
 */
const initHeaderScroll = () => {
  const header = $("header");
  const mainNav = $(".main-nav");
  if (!header || !mainNav) return;

  let lastScrollY = window.scrollY;
  let ticking = false;
  const scrollThreshold = 100;

  const updateHeader = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY && currentScrollY > scrollThreshold) {
      // Scrolling down & past threshold
      addClass(header, "header--hidden");
    } else {
      // Scrolling up
      removeClass(header, "header--hidden");
    }

    // White background when not at top
    if (currentScrollY > scrollThreshold) {
      addClass(mainNav, "main-nav--white");
    } else {
      removeClass(mainNav, "main-nav--white");
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });
};
